/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileResponseModel } from '../../models/profile-response-model';

export interface ScanProfileProfileIdGet$Params {

/**
 * The unique identifier of the profile
 */
  profileId: string;
}

export function scanProfileProfileIdGet(http: HttpClient, rootUrl: string, params: ScanProfileProfileIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ProfileResponseModel>> {
  const rb = new RequestBuilder(rootUrl, scanProfileProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ProfileResponseModel>;
    })
  );
}

scanProfileProfileIdGet.PATH = '/Scan/Profile/{profileId}';
